import script from "./CreateIllustrationView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateIllustrationView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__